import React from 'react'
import Nav from './Nav'
import './Home.css'
function Home() {
    return (
        <div>
         <Nav/>   
        </div>
    )
}

export default Home
